import React, { useState, useEffect } from 'react';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import './ModalCreateEditUser.scss';
import { toast } from 'react-toastify';
import { FaEye, FaEyeSlash } from "react-icons/fa";
import _ from "lodash";
import { updatePasswordUser } from '../../services/userServices';

const ModalChangePassword = (props) => {
    const { dataModalUserUpdate } = props;

    const validInputDefault = {
        oldPassword: true,
        password: true,
        repassword: true,
    };

    const defaultUserData = {
        userCode: '',
        oldPassword: '',
        password: '',
        repassword: ''
    };

    const [showOldPassword, setShowOldPassword] = useState(false);
    const [showPassword, setShowPassword] = useState(false);
    const [showRePassword, setShowRePassword] = useState(false);
    const [validInput, setValidInput] = useState(validInputDefault);
    const [userData, setUserData] = useState(defaultUserData);
    const [isSaveDisabled, setIsSaveDisabled] = useState(true);

    const togglePasswordVisibility = () => {
        setShowPassword(!showPassword);
    };

    const toggleRePasswordVisibility = () => {
        setShowRePassword(!showRePassword);
    };

    const toggleOldPasswordVisibility = () => {
        setShowOldPassword(!showOldPassword);
    };

    useEffect(() => {
        setUserData({
            ...defaultUserData,
            repassword: '',
            userCode: dataModalUserUpdate?.userCode || ''
        });
        setIsSaveDisabled(true);
    }, [props.isShow, dataModalUserUpdate]);

    const handleOnchangeInput = (value, name) => {
        let _userData = _.cloneDeep(userData);
        _userData[name] = value;
        setUserData(_userData);

        if (!_userData.oldPassword && !_userData.password && !_userData.repassword)
            setIsSaveDisabled(true);
        else
            setIsSaveDisabled(false);
    };

    const isEmptyInput = () => {
        setValidInput(validInputDefault);
        let arr = ['oldPassword', 'password', 'repassword'];
        let check = true;

        for (let i = 0; i < arr.length; i++) {
            if (!userData[arr[i]]) {
                let _validInput = _.cloneDeep(validInputDefault);
                _validInput[arr[i]] = false;
                setValidInput(_validInput);

                toast.error(`Vui lòng nhập ${arr[i] === 'oldPassword' ? 'Mật khẩu cũ' : arr[i] === 'password' ? 'Mật khẩu mới' : 'Nhập lại mật khẩu mới'}`);
                check = false;
                break;
            }
        }
        return check;
    };

    const isValidValue = () => {
        const regexPwd = /^[\s\S]{7,16}$/;

        if (regexPwd.test(userData['oldPassword']) === false) {
            toast.error('Mật khẩu cũ phải từ 7 - 16 ký tự');
            setValidInput({ ...validInputDefault, oldPassword: false });
            return false;
        } else {
            setValidInput({ ...validInputDefault, oldPassword: true });
        }

        if (regexPwd.test(userData['password']) === false) {
            toast.error('Mật khẩu mới phải từ 7 - 16 ký tự');
            setValidInput({ ...validInputDefault, password: false });
            return false;
        } else {
            setValidInput({ ...validInputDefault, password: true });
        }

        if (userData['password'] !== userData['repassword']) {
            toast.error('Mật khẩu nhập lại không trùng khớp');
            setValidInput({ ...validInputDefault, password: false, repassword: false });
            return false;
        } else {
            setValidInput({ ...validInputDefault, password: true, repassword: true });
        }

        if (userData['oldPassword'] === userData['password']) {
            toast.error('Mật khẩu mới không được trùng với mật khẩu cũ');
            setValidInput({ ...validInputDefault, oldPassword: false, password: false });
            return false;
        } else {
            setValidInput({ ...validInputDefault, oldPassword: true, password: true });
        }

        return true;
    };

    const isValidInput = () => {
        return isEmptyInput() && isValidValue();
    };

    const handleConfirmUser = async () => {
        if (isValidInput()) {
            let response = await updatePasswordUser(userData);
            if (response && response.ok) {
                toast.success(response.message || 'Đổi mật khẩu thành công!');
                handleCloseModalUser();
            } else {
                toast.error(response?.message || 'Đổi mật khẩu thất bại!');
            }
        }
    };

    const handleCloseModalUser = () => {
        props.onClose();
        setUserData(defaultUserData);
        setValidInput(validInputDefault);
    };

    return (
        <Modal show={props.isShow} className='modal-edit' onHide={handleCloseModalUser} centered>
            <Modal.Header closeButton>
                <Modal.Title>
                    <i className="bi bi-shield-lock text-primary"></i>
                    Đổi mật khẩu tài khoản
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <div className="notice-box mb-3">
                    <i className="bi bi-info-circle-fill"></i>
                    <span>Mật khẩu mới cần từ 7 - 16 ký tự và khác mật khẩu hiện tại.</span>
                </div>

                <div className='form-group'>
                    <label>Mật khẩu hiện tại:</label>
                    <div className='input-group-pwd'>
                        <input
                            className={validInput.oldPassword ? 'form-control' : 'form-control is-invalid'}
                            type={showOldPassword ? 'text' : 'password'}
                            placeholder="Nhập mật khẩu hiện tại..."
                            onChange={(event) => handleOnchangeInput(event.target.value, "oldPassword")}
                        />
                        <button
                            type="button"
                            className="password-toggle-btn"
                            onClick={toggleOldPasswordVisibility}
                        >
                            {showOldPassword ? <FaEyeSlash /> : <FaEye />}
                        </button>
                    </div>
                    {!validInput.oldPassword && <span className='err'>Nhập đúng mật khẩu cũ của bạn</span>}
                </div>

                <div className='form-group'>
                    <label>Mật khẩu mới:</label>
                    <div className='input-group-pwd'>
                        <input
                            className={validInput.password ? 'form-control' : 'form-control is-invalid'}
                            type={showPassword ? 'text' : 'password'}
                            placeholder="Nhập mật khẩu mới..."
                            onChange={(event) => handleOnchangeInput(event.target.value, "password")}
                        />
                        <button
                            type="button"
                            className="password-toggle-btn"
                            onClick={togglePasswordVisibility}
                        >
                            {showPassword ? <FaEyeSlash /> : <FaEye />}
                        </button>
                    </div>
                    {!validInput.password && <span className='err'>Độ dài 7-16 ký tự, khác mật khẩu cũ</span>}
                </div>

                <div className='form-group mb-0'>
                    <label>Xác nhận mật khẩu mới:</label>
                    <div className='input-group-pwd'>
                        <input
                            className={validInput.repassword ? 'form-control' : 'form-control is-invalid'}
                            type={showRePassword ? 'text' : 'password'}
                            placeholder="Nhập lại mật khẩu mới..."
                            onChange={(event) => handleOnchangeInput(event.target.value, "repassword")}
                        />
                        <button
                            type="button"
                            className="password-toggle-btn"
                            onClick={toggleRePasswordVisibility}
                        >
                            {showRePassword ? <FaEyeSlash /> : <FaEye />}
                        </button>
                    </div>
                    {!validInput.repassword && <span className='err'>Mật khẩu nhập lại phải trùng khớp</span>}
                </div>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={handleCloseModalUser}>Hủy bỏ</Button>
                <Button variant="primary" disabled={isSaveDisabled} onClick={handleConfirmUser}>
                    <i className="bi bi-key-fill me-1"></i>
                    Đổi mật khẩu
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

export default ModalChangePassword;